<div
  class="bg-white w-78 h-50 shadow-md flex flex-col items-center justify-center rounded-xl cursor-pointer"
>
  <img src="icons/upload_icon.svg" class="mb-6" />
  <p class="text-th-black text-[18px] font-medium mb-4">Carga un CV actualizado</p>
  <p class="text-[#767F8C] text-[14px] font-normal">Archivo PDF</p>
</div>
